export function logError(error: unknown, info?: { componentStack?: string }) {
  console.error("[ErrorBoundary]", error, info);
}
